import React, { useEffect, useState } from 'react';
import styles from '../../src/assets/scss/Profile.module.scss';
import { getUserInfo } from '../utils/user.util';
import { useGetUserByIdQuery } from '../slices/admin/admin';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BaseURL } from '../lib/api';
import dummyProfile from "../assets/images/Profile.png";
import { useNavigate } from 'react-router-dom';

const Profile = () => {
    const user = getUserInfo();
 const navigate = useNavigate();
    //console.log(`User Info:`, user);

    const userId = user?._id;

    const { data, isLoading, error, refetch } = useGetUserByIdQuery(userId, { skip: !userId });

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        userName: '',
        password: '******',
        userType: 'Customer',
        personalAddress: '',
        organizationName: '',
        gst: '',
        paymentDetails: 'bank',
        bankName: '',
        bankAccount: '',
        confirmBankAccount: '',
        bankIfsc: '',
        upiId: '',
        address1: '',
        address2: '',
        pincode: '',
        city: '',
        state: '',
    });

    const [errors, setErrors] = useState({});
    const [profileImage, setProfileImage] = useState(dummyProfile);
    const [profileFile, setProfileFile] = useState(null);

    const [orgLogoFile, setOrgLogoFile] = useState(null);
    const [orgLogoPreview, setOrgLogoPreview] = useState(null);

    const handleOrgLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setOrgLogoFile(file);
            setOrgLogoPreview(URL.createObjectURL(file));
        }
    };


    useEffect(() => {
        if (data?.result?.length > 0) {
            const u = data.result[0];
            const bank = u.banks?.[0] || {};
            const store = u.store || {};

            setFormData((prev) => ({
                ...prev,
                firstName: u.firstName || '',
                lastName: u.lastName || '',
                email: u.email || '',
                phone: u.phone || '',
                userName: u.userName || '',
                userType: u.type || '',
                personalAddress: store.address || '',
                organizationName: store.storeName || '',
                gst: store.gst || '',
                address1: store.address1 || '',
                address2: store.address2 || '',
                pincode: store.pincode?.toString() || '',
                city: store.city || '',
                state: store.state || '',
                bankName: bank.bankName || '',
                bankAccount: bank.accountNo || '',
                confirmBankAccount: bank.accountNo || '',
                bankIfsc: bank.ifsc || '',
                upiId: bank.upiId || '',
                paymentDetails: bank.paymentType || 'bank',
            }));


            // if (u.profile) {
            //     setProfileImage(`${BaseURL}/${u.profile}`);
            // }
            // if (store.logo) {
            //     setOrgLogoPreview(`${BaseURL}/${store.logo}`);
            // }
            if (u.profile && typeof u.profile === 'string') {
                const profileUrl = u.profile.startsWith("http")
                    ? u.profile
                    : `${BaseURL}/${u.profile}`;
                setProfileImage(profileUrl);
            } else {
                setProfileImage(dummyProfile);
            }

            if (store.logo && typeof store.logo === 'string') {
                const logoUrl = store.logo.startsWith("http")
                    ? store.logo
                    : `${BaseURL}/${store.logo}`;
                setOrgLogoPreview(logoUrl);
            } else {
                setOrgLogoPreview(dummyProfile);
            }

        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if ((name === 'firstName' || name === 'lastName') && /[^a-zA-Z\s]/.test(value)) return;
        if (name === 'phone' && (!/^\d*$/.test(value) || value.length > 10 || (value.length === 1 && !/^[6-9]$/.test(value)))) return;

        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    // const validate = () => {
    //     const newErrors = {};

    //     if (!formData.firstName) newErrors.firstName = 'First name is required';
    //     if (!formData.lastName) newErrors.lastName = 'Last name is required';
    //     if (!formData.userName) newErrors.userName = 'Username is required';
    //     if (!formData.phone) newErrors.phone = 'Phone number is required';
    //     if (!formData.email) newErrors.email = 'Email is required';
    //     if (!formData.bankName) newErrors.bankName = 'Bank name is required';
    //     if (!formData.bankAccount) newErrors.bankAccount = 'Account number is required';
    //     if (!formData.bankIfsc) newErrors.bankIfsc = 'IFSC code is required';
    //     if (!formData.paymentDetails) newErrors.paymentDetails = 'Payment method is required';

    //     if (
    //         formData.paymentDetails &&
    //         formData.paymentDetails.toLowerCase() === 'upi' &&
    //         !formData.upiId
    //     ) {
    //         newErrors.upiId = 'UPI ID is required';
    //     }

    //     if (user?.type !== 'employee') {
    //         if (!formData.organizationName) newErrors.organizationName = 'Organization name is required';
    //         // if (!formData.gst) newErrors.gst = 'GST number is required';
    //         if (!formData.address1) newErrors.address1 = 'Address1 is required';
    //         if (!formData.city) newErrors.city = 'City is required';
    //         if (!formData.state) newErrors.state = 'State is required';
    //         if (!formData.pincode) newErrors.pincode = 'Pincode is required';
    //     }

    //     return newErrors;
    // };



    // const validate = () => {
    //     const newErrors = {};

    //     // Always required
    //     if (!formData.firstName) newErrors.firstName = 'First name is required';
    //     if (!formData.lastName) newErrors.lastName = 'Last name is required';
    //     if (!formData.userName) newErrors.userName = 'Username is required';
    //     if (!formData.phone) newErrors.phone = 'Phone number is required';
    //     if (!formData.email) newErrors.email = 'Email is required';

    //     // Only validate fields based on payment type
    //     if (formData.paymentDetails?.toLowerCase() === 'bank') {
    //         if (!formData.bankName) newErrors.bankName = 'Bank name is required';
    //         if (!formData.bankAccount) newErrors.bankAccount = 'Account number is required';
    //         if (!formData.confirmBankAccount) newErrors.confirmBankAccount = 'Confirm account number is required';
    //         if (!formData.bankIfsc) newErrors.bankIfsc = 'IFSC code is required';
    //     } else if (formData.paymentDetails?.toLowerCase() === 'upi') {
    //         if (!formData.upiId) newErrors.upiId = 'UPI ID is required';
    //     }

    //     // Only validate these if NOT employee
    //     if (user?.type !== 'employee') {
    //         if (!formData.organizationName) newErrors.organizationName = 'Organization name is required';
    //         if (!formData.address1) newErrors.address1 = 'Address1 is required';
    //         if (!formData.city) newErrors.city = 'City is required';
    //         if (!formData.state) newErrors.state = 'State is required';
    //         if (!formData.pincode) newErrors.pincode = 'Pincode is required';
    //     }

    //     return newErrors;
    // };

    const validate = () => {
        const newErrors = {};

        // ✅ Always required
        if (!formData.firstName) newErrors.firstName = 'First name is required';
        if (!formData.lastName) newErrors.lastName = 'Last name is required';
        if (!formData.userName) newErrors.userName = 'Username is required';
        if (!formData.phone) newErrors.phone = 'Phone number is required';
        if (!formData.email) newErrors.email = 'Email is required';

        // ✅ Payment Information (completely optional)
        // No validation for paymentDetails, bankName, account, IFSC, UPI, etc.

        // ✅ Only validate these if NOT employee
        if (user?.type !== 'employee') {
            if (!formData.organizationName) newErrors.organizationName = 'Organization name is required';
            if (!formData.address1) newErrors.address1 = 'Address1 is required';
            if (!formData.city) newErrors.city = 'City is required';
            if (!formData.state) newErrors.state = 'State is required';
            if (!formData.pincode) newErrors.pincode = 'Pincode is required';
        }

        return newErrors;
    };


    const handleSubmit = async () => {
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            const payload = new FormData();

            // Basic fields (always required)
            payload.append('firstName', formData.firstName);
            payload.append('lastName', formData.lastName);
            payload.append('userName', formData.userName);
            payload.append('email', formData.email || '');
            payload.append('phone', formData.phone);

            // Conditional: org/address fields only if not employee
            if (user?.type !== 'employee') {
                payload.append('storeName', formData.organizationName || '');
                payload.append('address1', formData.address1 || '');
                payload.append('address2', formData.address2 || '');
                payload.append('pincode', formData.pincode || '');
                payload.append('city', formData.city || '');
                payload.append('state', formData.state || '');
            }

            // Optional fields (safe appending)
            payload.append('gst', formData.gst || '');
            payload.append('bankName', formData.bankName || '');
            payload.append('accountNo', formData.bankAccount || '');
            payload.append('ifsc', formData.bankIfsc || '');
            payload.append('paymentType', formData.paymentDetails?.toLowerCase() || '');
            payload.append('upiId', formData.upiId || '');

            // ✅ Profile image (field name: profile)
            if (profileFile) {
                payload.append('profile', profileFile);
            }

            // ✅ Organization logo (field name: logo)
            if (orgLogoFile) {
                payload.append('logo', orgLogoFile);
            }

            try {
                const response = await axios.put(
                    `${BaseURL}/user/updateProfile/${userId}`,
                    payload,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${user?.token}`,
                        },
                    }
                );

                toast.success(response.data.message || 'Profile updated successfully');
                refetch();
            } catch (error) {
                toast.error(error.response?.data?.message || 'Failed to update profile');
            }
        }
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileFile(file);
            const reader = new FileReader();
            reader.onload = () => setProfileImage(reader.result);
            reader.readAsDataURL(file);
        }
    };

    if (isLoading) return <p>Loading profile...</p>;
    if (error) return <p>Error loading profile.</p>;


    return (
        <div className={styles.profileContainerinside}>
            <h2 className={styles.title}>My Profile</h2>

            {/* Basic Info */}
            <div className={styles.card}>
                <div className={styles.header}>
                    <h3 className={styles.Heading}>👤 Basic Information</h3>
                </div>
                <div className={styles.imageSection}>
                    <div className={styles.Dflex}>
                        <div className={styles.imageContainer}>
                            <img src={profileImage} alt="profile" className={styles.profileImage} />
                            <div>
                                <div className={styles.changeImageContainer}>
                                    <label htmlFor="imageInput" className={styles.changeImageButton}>
                                        Change Image
                                    </label>
                                </div>
                                <input
                                    id="imageInput"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ display: 'none' }}
                                />
                                <p className={styles.imageInfo}>Upload image below 2MB (JPG, PNG)</p>
                            </div>
                        </div>
                        <div className={styles.userInfoBox}>
                            <div className={styles.userInfoRow}>
                                <label className={styles.userInfoLabel}>User Type :</label>
                                <div className={styles.userInfoValue}>{formData.userType || "-"}</div>
                            </div>
                            <div className={styles.userInfoRow}>
                                <label className={styles.userInfoLabel}>User Name :</label>
                                <div className={styles.userInfoValue}>{formData.userName || "-"}</div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className={styles.content}>
                    <div className={styles.formSection}>
                        <div className={styles.inputGroupheader}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>First Name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    className={styles.input}
                                    onKeyDown={(e) => {
                                        if (e.target.selectionStart === 0 && e.key === " ") {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {errors.firstName && <span className={styles.error}>{errors.firstName}</span>}
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Last Name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    className={styles.input}
                                    onKeyDown={(e) => {
                                        if (e.target.selectionStart === 0 && e.key === " ") {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {errors.lastName && <span className={styles.error}>{errors.lastName}</span>}
                            </div>
                        </div>

                        <div className={styles.inputGroupheader}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Email ID</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Email ID"
                                    className={styles.input}
                                    onKeyDown={(e) => {
                                        if (e.target.selectionStart === 0 && e.key === " ") {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {errors.email && <span className={styles.error}>{errors.email}</span>}
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Phone Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Phone Number"
                                    maxLength="10"
                                    className={styles.input}
                                    onKeyDown={(e) => {
                                        if (e.target.selectionStart === 0 && e.key === " ") {
                                            e.preventDefault();
                                        }
                                    }}
                                />

                                {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                            </div>
                        </div>

                        <div className={styles.inputGroupheader}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    className={styles.input}
                                    disabled
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                {/* <label className={styles.inputLabel}>User Name :</label>
                                <input
                                    type="text"
                                    name="userName"
                                    value={formData.userName}
                                    onChange={handleChange}
                                    placeholder="User Name"
                                    className={styles.input}
                                    onKeyDown={(e) => {
                                        if (e.target.selectionStart === 0 && e.key === " ") {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {errors.userName && <span className={styles.error}>{errors.userName}</span>} */}
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.buttonGroup} style={{ marginTop: '20px' }}>
                    <button className={styles.cancelButton} onClick={() => navigate('/dashboard')}>
                        Cancel
                    </button>
                    <button className={styles.saveButton} onClick={handleSubmit}>
                        Save Changes
                    </button>
                </div>
            </div>

            {/* Address Info removed and moved to OrganizationSettings */}
            {/* Payment Info removed and moved to PaymentSettings */}

        </div>
    );
};

export default Profile;



